(() => {
  const key = 'ib-inquiry-pending';
  const inquiryForms = [...document.querySelectorAll('form.ib-bridal-form, form.ib-contact__form')];
  const kind = form => form.querySelector('[name="contact[source]"]')?.value.startsWith('bridal-') ? 'bridal' : 'contact';
  inquiryForms.filter(form => form.classList.contains('ib-contact__form')).forEach(form => {
    const subject = form.querySelector('[name="contact[subject]"]');
    const preference = form.querySelector('[data-ib-consultation-preference]');
    const source = form.querySelector('[name="contact[source]"]');
    let pending;
    try { pending = JSON.parse(sessionStorage.getItem(key)); } catch {}
    if (new URL(location.href).searchParams.get('subject') === 'bridal' || (form.querySelector('[data-ib-form-success]') && pending?.kind === 'bridal')) subject.value = 'Consultație bridal';
    const sync = () => {
      const bridal = subject.value === 'Consultație bridal';
      if (source) source.value = bridal ? 'bridal-contact' : 'contact';
      if (preference) { preference.hidden = !bridal; preference.querySelector('select').disabled = !bridal; }
    };
    subject.addEventListener('change', sync); sync();
    const success = form.querySelector('[data-ib-form-success]');
    if (success && pending?.kind === 'bridal') success.textContent = form.querySelector('[data-ib-bridal-success]').textContent;
  });
  function reset(form) {
    form.removeAttribute('aria-busy'); delete form.dataset.ibSubmitting;
    form.querySelectorAll('[type="submit"]').forEach(button => button.disabled = false);
  }
  inquiryForms.forEach(form => {
    form.addEventListener('submit', event => {
      if (!form.checkValidity()) return;
      if (form.dataset.ibSubmitting === 'true') { event.preventDefault(); return; }
      // This handler never displays success. Only the server's rendered success does.
      if (event.defaultPrevented) return;
      form.dataset.ibSubmitting = 'true'; form.setAttribute('aria-busy', 'true');
      try { sessionStorage.setItem(key, JSON.stringify({kind: kind(form), at: Date.now(), id: crypto.randomUUID()})); } catch {}
      form.querySelectorAll('[type="submit"]').forEach(button => button.disabled = true);
      // A failed navigation/captcha must allow a deliberate retry.
      setTimeout(() => reset(form), 15000);
    });
    const status = form.querySelector('[data-ib-form-success], [data-ib-form-error]');
    if (!status) return;
    reset(form);
    form.closest('dialog-component')?.showDialog?.();
    status.tabIndex = -1; status.focus();
    let pending;
    try { pending = JSON.parse(sessionStorage.getItem(key)); sessionStorage.removeItem(key); } catch {}
    if (status.hasAttribute('data-ib-form-success') && pending?.kind === kind(form) && Date.now() - pending.at < 3600000) {
      document.dispatchEvent(new CustomEvent('ib:inquiry-success', {detail: {kind: pending.kind, eventId: pending.id}}));
    }
  });
  window.addEventListener('pageshow', () => inquiryForms.forEach(reset));
})();
